import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom'
import { getEssentialClassics} from '../../actions/PlaylistActions'
import { useDispatch, useSelector } from 'react-redux'
import ArrowRight from '../icons/Arrow_right.svg'
import Slider from '../slides/Slider';
import ViewAll from '../icons/ViewAllBlue.svg'

const EssentialClassics = (props) => {

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const { essentialClassics } = useSelector(state => state.essentialClassics)



    useEffect(()=>{
        if (!essentialClassics || !essentialClassics.videos || !essentialClassics.videos.length){
            dispatch(getEssentialClassics())
        }
    },[dispatch])


    const itemClickHandler = (item) => {
        localStorage.setItem('video_id', item.id)
        localStorage.setItem('playlist_id', 251)
        localStorage.setItem('group_id', 10)
        if(props.user) {
          navigate(encodeURI(`/home?g=${10}&p=${251}&v=${item.id}`, {replace: false} ))
        } else {
            localStorage.setItem("path", encodeURI(`/home?g=${10}&p=${251}&v=${item.id}`))
            navigate('/login')
        }
      }

      const viewAllHandler = () => {
        navigate(encodeURI(`/playlist/251/Essential Classics`))
      }


    return (
        <div className="col-12" style = {{marginTop:"2.5vw"}}>

            <div className='position-relative' id = "carouselListWrapper">
                {
                    essentialClassics && essentialClassics.videos && essentialClassics.videos.length ?
                    <Slider
                        num = {5}
                        type = {2}
                        showTitle = {true}
                        tvData={essentialClassics.videos}
                        slideClickHandler={itemClickHandler}
                        slideTitle = {"New Audio / Best on YouTube"}
                        showAllHandler = {viewAllHandler}
                    /> : ""
                }
            </div>
        </div>
    );
};

export default EssentialClassics;